    import React, { useEffect } from 'react'
    import { GoogleMap, useJsApiLoader } from '@react-google-maps/api'
    import { mapOptions } from '../../config-map'
    import './map.scss'
    import { getApiMapKey } from '../../api/google-integration'

    declare const google

    interface IProps {
        zoom: number
        children: any
        center: any
        onLoad: any
        options?: any
        mapContainerClassName?: string
    }

    const libraries = ['places', 'geometry']

    const Map = ({ zoom, children, center, onLoad, options = mapOptions, mapContainerClassName }: IProps): JSX.Element => {
        const { isLoaded, loadError } = useJsApiLoader({
            googleMapsApiKey: getApiMapKey(),
            libraries: libraries
        })

        const renderMap = (): JSX.Element => {
            return (
                <div className="container-map">
                    <GoogleMap
                        id="map-markers"
                        onLoad={onLoad}
                        mapContainerClassName={mapContainerClassName}
                        options={options}
                        zoom={5}
                        // restriction= {{
                        //     latLngBounds: {
                        //       north: -10,
                        //       south: -40,
                        //       east: 160,
                        //       west: 100,
                        //     },
                        //   }}
                        center={center}
                    >
                        {children}
                    </GoogleMap>
                </div>
            )
        }

        if (loadError) {
            return <div>Map cannot be loaded right now, sorry.</div>
        }

        return isLoaded ? renderMap() : <div> CARREGANDO...</div>
    }

    export default Map
